import { combineReducers } from 'redux';
import getApiReducer from '../util/get-api-reducer';
import { CREATE_LEAD } from './lead-actions';

const reducers = combineReducers({
  createLead: getApiReducer(CREATE_LEAD),
});

export default reducers;
